class StoreLocator {
  constructor() {
    this.mapboxgl = window.mapboxgl;
    this.mapboxgl.accessToken =
      "pk.eyJ1IjoibWF0aGlhc25vdmFzIiwiYSI6ImNtYTN1bDRkajAwYTIybHNhbGoxbzg2am4ifQ.TeoZaON49Cewrn8a6dadlg";

    // Initialize DOM elements
    this.storesContainer = document.querySelector(".store-locator-stores");
    this.stores = JSON.parse(this.storesContainer.getAttribute("data-stores"));
    this.cityItems = document.querySelectorAll(".store-locator-city");
    this.citiesList = document.querySelector(".store-locator-cities");
    this.storesList = document.querySelector(".store-locator-stores");
    this.searchResultsList = document.querySelector(
      ".store-locator-search-results"
    );
    this.searchInput = document.querySelector(".store-locator-search-input");
    this.searchResultsContainer = document.querySelector(
      ".store-locator-search-results__list"
    );
    this.backButtons = document.querySelectorAll(".store-locator-back");

    // Initialize map
    this.map = new this.mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/light-v11",
      center: [10.73216367, 59.91466633],
      zoom: 13,
      scrollZoom: false,
    });

    this.init();
  }

  init() {
    this.map.on("load", () => {
      this.map.addSource("places", {
        type: "geojson",
        data: this.stores,
      });
      this.addMarkers();
    });

    this.setupEventListeners();
  }

  addMarkers() {
    this.stores.forEach((marker, index) => {
      const el = document.createElement("div");
      el.id = `marker-${index}`;
      el.className = "marker";

      el.addEventListener("click", () => {
        this.flyToStore([marker.lng, marker.lat]);
        this.createPopUp({
          geometry: {
            coordinates: [marker.lng, marker.lat],
          },
          properties: {
            name: marker.name,
            address: marker.address,
            city: marker.city,
          },
        });
      });

      new this.mapboxgl.Marker(el, { offset: [0, -23] })
        .setLngLat([marker.lng, marker.lat])
        .addTo(this.map);
    });
  }

  flyToStore(coordinates) {
    this.map.flyTo({
      center: coordinates,
      zoom: 15,
    });
  }

  createPopUp(currentFeature) {
    const popUps = document.getElementsByClassName("mapboxgl-popup");
    if (popUps[0]) popUps[0].remove();

    const popup = new this.mapboxgl.Popup({ closeOnClick: false })
      .setLngLat(currentFeature.geometry.coordinates)
      .setHTML(
        `
        <h5>${currentFeature.properties.name}</h5>
        <div class="store-locator-store__address">${
          currentFeature.properties.address
        } ${
          currentFeature.properties.city
            ? ` — ${currentFeature.properties.city}`
            : ""
        }</div>
        <a
          class="store-locator-store__directions"
          target="_blank"
          href="//www.google.com/maps/dir/?api=1&destination=${
            currentFeature.geometry.coordinates[1]
          },${currentFeature.geometry.coordinates[0]}"
        >
          Veibeskrivelse til butikk
        </a>
      `
      )
      .addTo(this.map);
  }

  setupEventListeners() {
    // Setup store list items
    this.stores.forEach((store, index) => {
      const storeListItem = document.getElementById(`store-${index}`);
      if (storeListItem) {
        storeListItem.addEventListener("click", () => {
          this.flyToStore([store.lng, store.lat]);
          this.createPopUp({
            geometry: {
              coordinates: [store.lng, store.lat],
            },
            properties: {
              address: store.address,
              name: store.name,
              city: store.city,
            },
          });
        });
      }
    });

    // Setup city items
    this.cityItems.forEach((city) => {
      city.addEventListener("click", () => {
        this.cityItems.forEach((c) => c.classList.remove("active"));
        city.classList.add("active");

        const selectedCity = city.textContent.trim();
        const stores = document.querySelectorAll(".store-locator-store");

        stores.forEach((store) => {
          const storeCity = store.dataset.city?.trim();
          const matchesSearch =
            !this.searchInput.value.trim() ||
            store.textContent
              .toLowerCase()
              .includes(this.searchInput.value.toLowerCase());
          const matchesCity =
            selectedCity === "Alle byer" ||
            (storeCity &&
              storeCity.toLowerCase() === selectedCity.toLowerCase());

          store.style.display = matchesSearch && matchesCity ? "" : "none";
        });

        this.citiesList.classList.remove("active");
        this.storesList.classList.add("active");
        this.searchResultsList.classList.remove("active");
      });
    });

    // Setup back buttons
    this.backButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.citiesList.classList.add("active");
        this.storesList.classList.remove("active");
        this.searchResultsList.classList.remove("active");
        this.searchInput.value = "";
      });
    });

    // Setup search functionality
    if (this.searchInput) {
      this.searchInput.addEventListener("input", (e) => {
        const query = e.target.value?.toLowerCase()?.trim();
        this.handleSearch(query);
      });
    } else {
      console.log("Search input not found");
    }
  }

  handleSearch(query) {
    const filteredStores = query
      ? this.stores.filter((store) => {
          const name = store.name?.toLowerCase();
          const address = store.address?.toLowerCase();
          const city = store.city?.toLowerCase();
          return (
            name.includes(query) ||
            address.includes(query) ||
            city.includes(query)
          );
        })
      : this.stores;

    this.updateSearchResults(filteredStores);
  }

  updateSearchResults(filteredStores) {
    this.searchResultsContainer.innerHTML = filteredStores
      .map(
        (store, index) => `
          <div
            class="store-locator-list-item store-locator-store"
            data-store-index="${index}"
            data-coordinates="${store.lng},${store.lat}"
            data-name="${store.name}"
            data-address="${store.address}"
            data-city="${store.city}"
          >
            <h5 class="store-locator-store__name">${store.name}</h5>
            <div class="store-locator-store__address">
              ${store.address}${store.city ? ` — ${store.city}` : ""}
            </div>
          </div>
        `
      )
      .join("");

    this.setupSearchResultHandlers();
  }

  setupSearchResultHandlers() {
    this.searchResultsContainer
      .querySelectorAll(".store-locator-store")
      .forEach((storeElement) => {
        storeElement.addEventListener("click", () => {
          const coordinates = storeElement.dataset.coordinates.split(",");
          if (coordinates) {
            this.flyToStore(coordinates);
            this.createPopUp({
              geometry: {
                coordinates,
              },
              properties: {
                address: storeElement.dataset.address,
                name: storeElement.dataset.name,
                city: storeElement.dataset.city,
              },
            });
          }
        });
      });

    this.citiesList.classList.remove("active");
    this.storesList.classList.remove("active");
    this.searchResultsList.classList.add("active");
  }
}

// Initialize the store locator
new StoreLocator();
